import Alert from '@mui/material/Alert';

export const ContextualFeesErrorAlert = () => {
  return (
    <Alert severity="warning" data-test="contextual-fees-error-alert" sx={{ mt: 2 }}>
      Contextual segment fees could not be loaded, so they are not shown here.
    </Alert>
  );
};
